import Modifier from 'ember-modifier';
import { buildWaiter } from '@ember/test-waiters';
const waiter = buildWaiter('@dashboard/shared-ui:auto-focus');
function isMarketInput(element) {
  return element.tagName === 'MARKET-INPUT-TEXT';
}
function delay(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}
async function autoFocus(element, named) {
  // Explicitly check if the "named" parameter has been passed in.
  // This is fugly but we want to support `{{auto-focus}}` as well as `{{auto-focus enabled=@autofocus}}`
  // If autofocus is undefined, default parameters won't work :(
  const args = {
    enabled: true,
    ...named
  };
  if (!args.enabled) {
    return;
  }
  if (!(element instanceof HTMLElement)) {
    throw new TypeError(`cannot focus ${element}, it is not HTMLElement`);
  }
  let toFocus = element;
  if (isMarketInput(element)) {
    await element.componentOnReady();
    toFocus = await element.getInputElement();
  }
  if (args.delay) {
    await delay(100);
  }
  toFocus.focus();
  if (args.select && toFocus instanceof HTMLInputElement) {
    toFocus.select();
  }
}
export default class AutoFocus extends Modifier {
  didInstall() {
    const token = waiter.beginAsync();
    autoFocus(this.element, this.args.named).finally(() => {
      waiter.endAsync(token);
    });
  }
}